export default "__VITE_ASSET__w15YOhSSH36nmn4m3s3ZCg__"